export default {"src":"/_next/static/media/money-pocket.d62cbb3b.svg","height":262,"width":137};